import styled from "@emotion/styled"
import { css } from "@emotion/react"
import Typography from "@mui/material/Typography"
import { Link } from "utils"
import { breakpoints } from "../../theme/mediaQueries"
import { sizes } from "../../theme/sizes"
import { colors } from "../../theme/colors"

export const Root = styled.div`
  width: 100%;
  background-color: ${colors.light.bg.primary};
  padding: ${sizes.spacing[48]}px 0;

  @media (min-width: ${breakpoints.lg}px) {
    padding: ${sizes.spacing[64]}px 0;
  }
`

export const PageTitle = styled(Typography)`
  color: ${colors.light.text.primary};
  font-weight: 700;
  margin: 0 0 ${sizes.spacing[40]}px 0;
  text-align: start;

  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: ${sizes.spacing[40]}px;
  }
`

export const IntroText = styled.p`
  color: ${colors.primitives.neutral500};
  margin: 0 0 ${sizes.spacing[32]}px 0;
  font-size: 16px;
  line-height: 24px;
  text-align: start;

  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: ${sizes.spacing[48]}px;
  }
`

export const SectionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${sizes.spacing[40]}px;

  @media (min-width: ${breakpoints.lg}px) {
    grid-template-columns: repeat(4, 1fr);
    gap: ${sizes.spacing[40]}px ${sizes.spacing[32]}px;
  }
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.spacing[12]}px;
`

export const SectionTitle = styled(Typography)`
  color: ${colors.light.text.primary};
  font-weight: 700;
  text-align: start;
`

export const LinkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.spacing[12]}px;
`

const linkStyles = css`
  text-decoration: none;
  color: ${colors.light.text.primary};
  transition: color 0.2s, text-decoration-color 0.2s;
  text-underline-offset: 4px;

  &:hover {
    color: ${colors.primitives.primary500};
    text-decoration: underline;
    text-decoration-color: ${colors.primitives.primary500};
  }

  @media (max-width: ${breakpoints.lg - 1}px) {
    font-size: 16px;
    line-height: 20px;
  }
`

export const SitemapLink = styled(Link)`
  ${linkStyles}
`
